import { useCallback, useRef, useEffect } from "react";
import { defaultHeaderContentHeight } from "@/store/pageModules/header";
import useOptimizedScroll from "@/src/hooks/useOptimizedScroll";

interface UseHeaderScrollBehaviorProps {
    headerRef: React.RefObject<HTMLDivElement>;
    headerContentHeight: number | null;
    hiddenWhenNoFixed?: boolean;
    anouncementHeaderHeight: number;
    setHeaderOptions: (options: Array<Partial<any>> | Partial<any>) => void;
}

export const useHeaderScrollBehavior = ({
    headerRef,
    headerContentHeight,
    hiddenWhenNoFixed,
    anouncementHeaderHeight,
    setHeaderOptions,
}: UseHeaderScrollBehaviorProps) => {
    // 滚动方向: wheel > 0 ？ 向上 ： 向下
    const lastScrollTop = useRef(0);

    // 当滚动高度超过顶部导航栏距离顶部高度时=>fixed
    const handleScroll = useCallback(() => {
        if (headerRef.current) {
            // 获取当前滚动位置
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // 简化的判断逻辑：基于滚动位置和公告栏高度
            const shouldFixHeader = scrollTop > anouncementHeaderHeight;

            // 更新header固定状态
            setHeaderOptions([{ fixedHeader: shouldFixHeader }]);

            // 更新滚动位置记录
            lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
        }
    }, [anouncementHeaderHeight, setHeaderOptions, headerRef]);

    // 初始化header固定状态
    useEffect(() => {
        // 确保公告栏高度已经计算完成后再初始化
        if (anouncementHeaderHeight > 0) {
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
            setHeaderOptions([
                {
                    fixedHeader: currentScrollY > anouncementHeaderHeight,
                },
            ]);
        }
    }, [anouncementHeaderHeight, setHeaderOptions]);

    // 绑定滚动监听
    useOptimizedScroll({ onScroll: handleScroll });
};
